import { getSelectedTableView } from 'owa-mail-list-store';
import type { ActionSource } from 'owa-mail-store';
import { resetFocus } from 'owa-mail-focus-manager';
import { lazyToggleIgnoreConversations } from 'owa-mail-triage-action';
import getEffectiveRowKeys from 'owa-mail-list-store/lib/utils/getEffectiveRowKeys';

export default async function onIgnoreStopIgnore(
    actionSource: ActionSource,
    shouldIgnore: boolean
): Promise<void> {
    const tableView = getSelectedTableView();
    const rowKeys = getEffectiveRowKeys(tableView);

    const toggleIgnoreConversations = await lazyToggleIgnoreConversations.import();
    toggleIgnoreConversations(rowKeys, tableView, shouldIgnore, actionSource);
    resetFocus('ignoreCommand');
}
